export function slugifyTemplateName(raw) {
  return String(raw || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 200);
}

export function buildTemplateExample(content) {
  const samples = ["João", "12345", "10/05", "R$ 99,90", "ABC"];
  return String(content || "").replace(/\{\{\s*([^}]+)\s*\}\}/g, (_, rawName) => {
    const name = String(rawName || "").trim();
    if (/^\d+$/.test(name)) {
      const idx = Math.max(0, Number(name) - 1);
      return samples[idx % samples.length];
    }
    if (!name) return "exemplo";
    return name.replace(/_/g, " ");
  });
}
